import { Para, Stack } from 'ui-components';
import ControlledSelectInput from './ControlledSelectInput';
import { BackStyle } from 'drycut-graphql';
import ControlledCheckboxInput from './ControlledCheckboxInput';

export default function LongHairOptions(): JSX.Element {
  const BackStyles: Record<BackStyle, string> = {
    [BackStyle.NotDefined]: '—',
    [BackStyle.Straight]: 'Gerade',
    [BackStyle.Rounded]: 'Abgerundet',
  };

  const backStyleOptions = Object.keys(BackStyles).map((key) => ({
    value: key,
    label: BackStyles[key as BackStyle],
  }));

  return (
    <Stack gap={2}>
      <Stack direction="row" className="w-full flex justify-between items-center min-h-10">
        <Para as="label" htmlFor="layers">
          Haare gestuft
        </Para>

        <ControlledCheckboxInput name="layers" />
      </Stack>

      <Stack direction="row" className="w-full flex justify-between">
        <Para as="label" htmlFor="backStyle">
          Haare hinten
        </Para>

        <ControlledSelectInput name="backStyle" options={backStyleOptions} />
      </Stack>
    </Stack>
  );
}
